import { render, staticRenderFns } from "./TabOVQuotationAndPayments.vue?vue&type=template&id=3240a610&scoped=true&lang=pug"
import script from "./TabOVQuotationAndPayments.vue?vue&type=script&lang=js"
export * from "./TabOVQuotationAndPayments.vue?vue&type=script&lang=js"
import style0 from "./TabOVQuotationAndPayments.vue?vue&type=style&index=0&id=3240a610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240a610",
  null
  
)

export default component.exports